// CartContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

// Create the context
const CartContext = createContext();

// Custom hook to access the context
export const useCart = () => useContext(CartContext);

// Provider component
export const CartProvider = ({ children }) => {
  const [couponctx, setCoupon] = useState("");
  const [messagefroAuth, setmessagefroAuth] = useState("");
  
  // Change orderNotesctx to an object: { [product_id]: { order_instruction, item } }
  const [orderNotesctx, setOrderNotes] = useState({});
  useEffect(() => {
    const formattedNotes = Object.entries(orderNotesctx).map(([product_id, data]) => ({
      product_id: Number(product_id),
      ...data
    }));
  
    localStorage.setItem("localNotes", JSON.stringify(formattedNotes));
  
    console.log("context1", JSON.stringify(formattedNotes));
  }, [orderNotesctx]);
  
  // Function to update the coupon
  const updateCouponctx = (newCoupon) => setCoupon(newCoupon);

  // ✅ Updated saveNotectx function
  const saveNotectx = (id, note, breakType,item) => {
    setOrderNotes((prevNotes) => ({
      ...prevNotes,
      [id]: { order_instruction: note,  break_type: breakType, item },
    }));
  };

  return (
    <CartContext.Provider value={{ messagefroAuth,setmessagefroAuth,couponctx, orderNotesctx,setOrderNotes, updateCouponctx, saveNotectx }}>
      {children}
      </CartContext.Provider>
    // </CartContext.Provider>
  );
};
